<template>
    <!-- Import Goal Modal -->
    <RightSideBar v-if="importGoalModal" @close="$emit('close')" width="width:500px" submit="Import"
      @submit="importTemplate()" button-class="bg-dynamicBackBtn text-white">
      <template v-slot:title>
        <div class="w-full flex justify-between">
          <span class="text-darkPurple font-bold text-lg leading-5 p-0">Import KPA Types</span>
        </div>
      </template>
      <template v-slot:subtitle>
        <div class="pb-5 flex flex-col">
          <span class="text-darkPurple text-base pb-4 leading-5 p-0">
            Please ensure that the goals you are importing align with the KPAs defined in your current goals.
          </span>
        </div>
      </template>
      <div class="w-full flex flex-col gap-2 mt-2">
        <div class="grid grid-cols-12 gap-4">
          <div class="col-span-12">
            <c-select label="Template" placeholder="Select Template" v-model="payload.templateId" variant="w-full"
              class="mt-1" :options="filteredTemplateOptions" :rules="['required']" />
          </div>
        </div>
      </div>
    </RightSideBar>

</template>


<script>
import CSelect from "@scelloo/cloudenly-ui/src/components/select";
import RightSideBar from '@/components/RightSideBar';

export default {
    name: "ImportGoal",
    components: {
        CSelect,
        RightSideBar
    },
    props: {
        importGoalModal: {
            type: Boolean,
            default: false
        },
        filteredTemplateOptions: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            payload: {
                templateId: ''
            }
        };
    },

    methods: {
        importTemplate() {
            if (this.payload.templateId) {
                this.$emit('import', this.payload.templateId);
                this.$emit('close');
            } else {
                this.$toast.error("Please select a template to import.");
            }
        }
    },
}
</script>